import styled from 'styled-components';

export const StyledWrapperDropdown = styled.article`
  width: 270px;
  min-height: 45px;
  max-height: 56px;

  @media screen and (min-width: 767.8px) {
    max-height: 65px;
  }
`;
